import * as formatter from "../../../../utils/formatter";
export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const sizePerPageList = [
  { text: "10개 보기", value: 10 },
  { text: "30개 보기", value: 30 },
];

export const initialFilter = {
  sortOrder: "desc",
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,
};

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "goodsNo",
    text: "상품 코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "catCd1",
    text: "카테고리",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.category,
  },
  {
    keyField: "no",
    dataField: "goodsNm",
    text: "상품명",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.prodName,
  },
  {
    keyField: "no",
    dataField: "normalPrc",
    text: "정가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "salePrc",
    text: "공급가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "saleAmt",
    text: "판매가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "optNm",
    text: "옵션",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.goodsListOpt,
  },
  {
    keyField: "no",
    dataField: "splyId",
    text: "공급 파트너",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "regDtime",
    text: "상품 등록일",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.date,
  }
];
